import { render, staticRenderFns } from "./IconWizardLink.vue?vue&type=template&id=df9f593e&"
import script from "./IconWizardLink.vue?vue&type=script&lang=ts&"
export * from "./IconWizardLink.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports